"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakPoints = void 0;
var react_1 = require("react");
var isExtraLarge = function () { return window.innerWidth >= 1600; };
var isLarge = function () { return window.innerWidth >= 1280 && window.innerWidth <= 1599; };
var isMedium = function () { return window.innerWidth >= 1024 && window.innerWidth <= 1279; };
var isSmall = function () { return window.innerWidth >= 768 && window.innerWidth <= 1023; };
var isExtraSmall = function () { return window.innerWidth < 768; };
var useBreakPoints = function () {
    var _a = (0, react_1.useState)(isExtraLarge()), extraLarge = _a[0], setExtraLarge = _a[1];
    var _b = (0, react_1.useState)(isLarge()), large = _b[0], setLarge = _b[1];
    var _c = (0, react_1.useState)(isMedium()), medium = _c[0], setMedium = _c[1];
    var _d = (0, react_1.useState)(isSmall()), small = _d[0], setSmall = _d[1];
    var _e = (0, react_1.useState)(isExtraSmall()), extraSmall = _e[0], setExtraSmall = _e[1];
    (0, react_1.useEffect)(function () {
        function handleResize() {
            setExtraLarge(isExtraLarge());
            setLarge(isLarge());
            setMedium(isMedium());
            setSmall(isSmall());
            setExtraSmall(isExtraSmall());
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, [setExtraLarge, setLarge, setMedium, setSmall, setExtraSmall]);
    return { extraLarge: extraLarge, large: large, medium: medium, small: small, extraSmall: extraSmall };
};
exports.useBreakPoints = useBreakPoints;
